<div class="tabs-bg">
  <div class="tabs">
    <button class="tab" [class.active]="selected() === 'pending'" (click)="setSelected('pending')">
      <span class="chip" [class.active]="selected() === 'pending'">
        <span class="label" [class.active]="selected() === 'pending'">Pending ({{ pendingCount }})</span>
      </span>
    </button>
    <button class="tab" [class.active]="selected() === 'outgoing'" (click)="setSelected('outgoing')">
      <span class="chip" [class.active]="selected() === 'outgoing'">
        <span class="label" [class.active]="selected() === 'outgoing'">Outgoing ({{ outgoingCount }})</span>
      </span>
    </button>
    <button class="tab" [class.active]="selected() === 'completed'" (click)="setSelected('completed')">
      <span class="chip" [class.active]="selected() === 'completed'">
        <span class="label" [class.active]="selected() === 'completed'">Completed ({{ completedCount }})</span>
      </span>
    </button>
  </div>
  <div class="tabs-note" *ngIf="selected() === 'pending'">Passports within the next 48hrs</div>
  <div class="outgoing-row" *ngIf="selected() === 'outgoing'">
    <span class="outgoing-text">Passports submitted but pending synchronisation.</span>
    <button type="button" class="resync-btn" *ngIf="isMobileMode" (click)="onResync()">Resync</button>
  </div>
</div>

